import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/BonusTracker';

export const BONUS_TRACKER_CLICK_HISTORY_GET_SUCCESS = `${rootActionPath}/clickHistory/GET_${SUCCESS_SUFFIX}`;
export const BONUS_TRACKER_CLICK_HISTORY_GET_FAILURE = `${rootActionPath}/clickHistory/GET_${FAILURE_SUFFIX}`;

export const BONUS_TRACKER_VIEW = `${rootActionPath}/VIEW`;
